import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmblaOptionsType } from 'embla-carousel';
import { useMediaQuery } from 'react-responsive';
import { Headline } from '../../../design-system';
import EmblaCarousel from '../EmblaCarousel';
import { TitleWrapper } from './FeaturedOffersList.styles';
import { PromotionType } from '../../types/offers';
import { device } from '../../styles/devices';
import { Text } from '@oneaudi/unified-web-alpha-components';

const OPTIONS: EmblaOptionsType = { loop: true };
const DESKTOP_OPTIONS: EmblaOptionsType = { loop: true, watchDrag: false };
const OPTIONS_ALPHA: EmblaOptionsType = { loop: true, align: 'start' };
const DESKTOP_OPTIONS_ALPHA: EmblaOptionsType = { loop: true, watchDrag: false, align: 'start' };

const FeaturedOffersList: React.FC<{
  featuredOffers: PromotionType[];
  isFiltersOpen?: boolean;
}> = ({ featuredOffers, isFiltersOpen }) => {
  const { t } = useTranslation();
  const isLaptop = useMediaQuery({ query: device.laptopMd });
  const isAlpha = !process.env.IS_LEGACY;

  if (!featuredOffers.length) return null;

  return (
    <>
      <TitleWrapper
        className={`${isAlpha ? 'title-wrapper-alpha' : ''}${isAlpha && !isFiltersOpen ? ' title-wrapper-alpha--filters-closed' : ''}`}
      >
        <Headline
          className={`${isAlpha ? 'headline-alpha' : ''}`}
          tag="h2"
          data-testid="header-copy"
          variant={{
            order: '2',
            type: 'headline',
            weight: 'normal',
          }}
        >
          {t('promo.offers.featuredOffersTitle')}
        </Headline>
        {isAlpha && (
          <Text className="featured-offers-amount">
            <b>{featuredOffers.length}</b> {t('promo.offers.featuredOffersAmountLabel')}
          </Text>
        )}
      </TitleWrapper>
      <EmblaCarousel
        slides={featuredOffers}
        isFiltersOpen={isFiltersOpen}
        options={
          !isAlpha
            ? isLaptop
              ? DESKTOP_OPTIONS
              : OPTIONS
            : isLaptop
              ? DESKTOP_OPTIONS_ALPHA
              : OPTIONS_ALPHA
        }
      />
    </>
  );
};

export default FeaturedOffersList;
